import { Tooltip } from 'antd';
import { QuestionCircleOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import type { MaintenanceSlaLevelCode } from '~/app/landing/sla/oems/components/MaintenanceSlaContract/types';

export interface MaintenanceSlaLevelHelpProps {
  code: MaintenanceSlaLevelCode;
}

export function MaintenanceSlaLevelHelp({
  code,
}: MaintenanceSlaLevelHelpProps) {
  const { t } = useTranslation('sla');

  return (
    <Tooltip
      title={
        <span>
          {t(`oems.maintenance.levelGuide.${code}.definition`)}
          <br />
          {t('oems.maintenance.examples')}:{' '}
          {t(`oems.maintenance.levelGuide.${code}.examples`)}
        </span>
      }
    >
      <QuestionCircleOutlined
        aria-label={t('oems.maintenance.levelHelp')}
        style={{ color: '#94a3b8', fontSize: 12 }}
        onClick={(event) => event.preventDefault()}
        onMouseDown={(event) => event.stopPropagation()}
      />
    </Tooltip>
  );
}
